function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
}
import { ScalarRef } from './scalar.js';
export class BuiltinScalarRef extends ScalarRef {
    constructor(type) {
        super(type.name), _define_property(this, "type", void 0);
        this.type = type;
    }
}
//# sourceMappingURL=builtin-scalar.js.map
